/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Contract, Signer, utils } from "ethers";
import { Provider } from "@ethersproject/providers";
import type {
  FixinProtocolFees,
  FixinProtocolFeesInterface,
} from "../FixinProtocolFees";

const _abi = [
  {
    inputs: [],
    name: "PROTOCOL_FEE_MULTIPLIER",
    outputs: [
      {
        internalType: "uint32",
        name: "",
        type: "uint32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
];

export class FixinProtocolFees__factory {
  static readonly abi = _abi;
  static createInterface(): FixinProtocolFeesInterface {
    return new utils.Interface(_abi) as FixinProtocolFeesInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): FixinProtocolFees {
    return new Contract(address, _abi, signerOrProvider) as FixinProtocolFees;
  }
}
